// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EDd_","label":"styles_label__3UpTI"};